import { z as zod } from 'zod';
import { HeroIntroSchema } from "@/app/features/shared/intros/hero/types/HeroIntro.schema";
import { MediaRefSchema } from "@/app/features/shared/__to_be_integrated/types/forms/MediaRefSchema";

export const SiteAuthenticPlacesSchema = zod.object({
    intro: HeroIntroSchema
});

const LocationSchema = zod.object({
    lat: zod.number(),
    lng: zod.number(),
})

export const AuthenticPlaceSchema = zod.object({
    title: zod.string().min(1, 'Der Titel darf nicht leer sein.'),
    description: zod.string().min(1, 'Die Beschreibung darf nicht leer sein.'),
    location: LocationSchema,
    image: MediaRefSchema,
    flyer: MediaRefSchema,
    routeDescription: zod.string().min(1, 'Die Routenbeschreibung darf nicht leer sein.'),
});